// Types
import { LIST_ACTIONS } from "./types";
import { SET_LIST } from "@/store/mutations-types";
// Services
import httpService from "@/services/http";

export default {
  state: {
    loading: false,
    model: {},
    params: {},
    list: [],
  },
  getters: {
    getListCards({ list }) {
      return list.reduce((newList, el) => {
        return newList.concat(el.performances ? el.performances : []);
      }, []);
    },
    getCard(state, getters) {
      return (id) => {
        return getters.getListCards.find((card) => card.id === id);
      };
    },
    flatList({ list }) {
      return list.flatMap(({ performances }) => performances);
    },
  },
  actions: {
    async [LIST_ACTIONS.GET_LIST]({ commit }) {
      const list = await httpService.getListPerformance();
      commit(SET_LIST, { name: LIST_ACTIONS.MODULE_LIST, list });
    },
  },
};
